export const safeFileName = (name, stripSpaces = false) => {
  let escaped = name.replace(/[/:*?"<>|]/g, ' ').trim();
  if (stripSpaces) escaped = escaped.replace(/\s+/g, '_');
  return escaped;
};